import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";
import _ from 'lodash';

// Validation schema
const AdminEditSchema = Yup.object().shape({
  password: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 15 symbols")
    .required("Password is required"),
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
  email: Yup.string()
    .required("Email is required"),

});

export function CreateAdminForm({
  admin,
  btnRef,
  saveAdmin,
}) {
  const [admin_role, setAdminRole] = useState('admin');

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={admin}
        validationSchema={AdminEditSchema}
        onSubmit={(values) => {
          let newvalues = _.cloneDeep(values)
          newvalues.role = admin_role;
          saveAdmin(newvalues);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-4">
                  <Field
                    name="name"
                    component={Input}
                    placeholder="name"
                    label="Name"
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    type="email"
                    name="email"
                    component={Input}
                    placeholder="email"
                    label="Email"
                  />
                </div>

                <div className="col-lg-4">
                  <Field
                    type="password"
                    name="password"
                    component={Input}
                    placeholder="password"
                    label="Password"
                  />
                </div>

              </div>
              <div className="form-group row">
                <div className="col-lg-4">
                  <Field
                    name="phone_number"
                    component={Input}
                    placeholder="phone number"
                    label="Phone number"
                  />
                </div>
                <div className="col-lg-4">
                  {/* Admin Roles field 1 mean viewer, 2 mean admin and 3 means super admin by default it is 2 i.e admin  */}
                  <label>Admin Role</label>
                  <select
                    className={`form-control }`}
                    value={admin_role}
                    onChange={(e) => setAdminRole(e.target.value)}
                  >
                    <option value="viewer">Viewer</option>
                    <option value="admin">Admin</option>
                    <option value="superadmin">Super Admin</option>
                  </select>
                </div>
              </div>

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
